export default {
  title: 'Suppliers',
  subTitle: 'A list of all Suppliers who supply raw materials known as Input Products to the company.',
  subTitleSecondLine: 'The company then uses those Input Products to produce the Output Product',
  totalPages: '{{offset}}-{{totalPages}} of {{total}}',
  archivingReasonTitle: 'Specify reason for archiving',
  archivingReasonDescription: 'Please provide a reason for archiving the selected record(s). You can restore '
        + 'them anytime.',
  archiveDetails: 'Archived record details',
  editInformation: 'Edit Information',
  addNewSupplier: 'Add New Supplier',
  editSupplier: 'Edit Supplier',
  fields: {
    action: 'Action',
    supplierName: 'Supplier Name',
    supplierCode: 'Supplier Code',
    uniqueIdentifier: 'Supplier System Unique Identifier',
    valueChain: 'Value Chain Position',
    upstreamTier: 'Upstream Tier',
    ownership: 'Ownership',
    equityShareholding: 'Equity Shareholding %',
    financialControl: 'Financial Control %',
    physicalOrLogical: 'Logical / Physical',
    dateOpened: 'Date Supplier Record Opened',
    profitCentreId: 'Profit Centre',
    dateClosed: 'Date Supplier Record Closed',
    industry: 'Industry (NACE)',
    sector: 'Sector (NACE)',
    taxonomy: 'EU Taxonomy Activity Code',
    startDate: 'FY Start Date',
    endDate: 'FY End Date',
    spend: 'Spend (rolling 12 months)',
    keySuppliers: 'Supplier Total Cost',
    keySuppliersInPercentage: 'Supplier % of Total Cost',
    rolling12Months: '(rolling 12 months)',
    country: 'Country of Operation / Incorporation',
    state: 'State / Region / County',
    post: 'Post Code',
    town: 'Town / City',
    street: 'Street',
    building: 'Building Name / Number',
    coordinates: 'Coordinates',
    actions: 'Actions',
    expectedGrowthDecline: 'Expected Growth / Decline %',
    sourceVCMId: 'Value Chain ID',
    estimated: 'Estimated',
  },
  selections: {
    general: 'General',
    details: 'Details',
    financials: 'Financials',
    address: 'Address',
  },
};
